module.exports = __webpack_public_path__ + "img/五星乡.0437f5fa.png";